export const isEllipsisActive = <T extends HTMLElement>(textContainer: T) =>
    textContainer.offsetHeight < textContainer.scrollHeight || textContainer.offsetWidth < textContainer.scrollWidth;
